<h1 class="text-center">Veelgestelde vragen</h1>

<div class="[ max-w-4xl w-full ] [ stack stack-space-3xl items-center ]">
  @if (isMaintenanceMode$ | async) {
    <campus-maintenance-mode
      [statusPageUrl]="statusPageUrl"
      class="[ m-b-m ]"
    ></campus-maintenance-mode>
  } @else {
    <section class="[ m-b-m ]">
      @if (selectedRole$ | async; as role) {
        <campus-chip-group class="[ flex justify-center ]">
          <campus-filter-chip
            label="voor leerlingen"
            [selected]="role === 'student'"
            (click)="roleClicked('student')"
          ></campus-filter-chip>
          <campus-filter-chip
            label="voor leerkrachten"
            [selected]="role === 'teacher'"
            (click)="roleClicked('teacher')"
          ></campus-filter-chip>
          <campus-filter-chip
            label="voor schoolbeheerders"
            [selected]="role === 'schooladmin'"
            (click)="roleClicked('schooladmin')"
          ></campus-filter-chip>
        </campus-chip-group>
      }
    </section>
    @if (filteredFaqCategories$ | async; as faqCategories) {
      <section class="[ reel reel-item-h-3xs reel-item-w-3xs overflowing max-w-full ]">
        @for (faqCategory of faqCategories; track trackById($index, faqCategory)) {
          <dcr-card
            type="button"
            [headline]="faqCategory.name"
            (click)="categoryClicked(faqCategory)"
            hero-type="image"
            >
            <dcr-image [src]="faqCategory.icon" [alt]="faqCategory.name" slot="hero"></dcr-image>
          </dcr-card>
        }
      </section>
      <div class="p-be-3xl">
        <section class="[ stack stack-space-3xl ]">
          @for (faqCategory of faqCategories; track trackById($index, faqCategory)) {
            <section>
              <div class="[ stack stack-space-3xs ]">
                @if (faqCategory.questions) {
                  <h2 [attr.id]="faqCategory.slug">{{ faqCategory.name }}</h2>
                  @for (question of faqCategory.questions; track trackBySlug($index, question)) {
                    <dcr-section
                      [attr.id]="question.slug"
                      [headline]="question.question"
                      [open]="(currentSlug$ | async) === question.slug"
                      [outline]="(currentSlug$ | async) === question.slug"
                      >
                      <dcr-inline-icon-button
                        [icon]="(copied$ | async) === question.slug ? 'portal:copied' : 'portal:link'"
                        slot="leading-image"
                        (click)="copyLink(question.slug, $event)"
                        aria-label="Kopieer link"
                      ></dcr-inline-icon-button>
                      <div [innerHTML]="question.answer | mathjax" class="body-large"></div>
                      @if (question.videoId) {
                        <campus-video-player
                          class="[ block ] [ m-bs-m ]"
                          [videoId]="question.videoId"
                          [player]="question.videoPlayer || videoPlayer"
                        ></campus-video-player>
                      }
                    </dcr-section>
                  }
                }
              </div>
            </section>
          }
        </section>
      </div>
      @if (windowScrolled$ | async) {
        <dcr-tonal-icon-button
          (click)="scrollToTop()"
          class="[ index-fab ] [ sticky bottom-xl self-end -right-m ] [ transform translate-x-1/2 elevation-4 ]"
          icon="navigation:arrow_upward"
          >
        </dcr-tonal-icon-button>
      }
    }
  }

</div>
